import ForwardSharpIcon from '@gamma/ui/icons/ForwardSharpIcon';
import moment from 'moment';
import { i18n } from '@investigator/shared/localization';

import { PillWrapper } from '.';
import { treatEscalationName } from '@investigator/shared/utils';
import { DetectionEscalationData } from '@investigator/shared/generated/graphql';

const { detection } = i18n.pages.detections;

interface SendToPillProps {
  escalation_data: DetectionEscalationData;
}

export const SendToPill = ({ escalation_data }: SendToPillProps) => {
  const treatedEscalationName =
    treatEscalationName(
      escalation_data?.escalation_service_name ?? undefined,
    ) || '';

  return (
    <PillWrapper
      label={`${i18n.formatString(
        detection.detectionIsSentBy,
        treatedEscalationName,
        escalation_data?.escalated_by_user_alias ?? '',
        escalation_data?.escalated_timestamp
          ? moment(escalation_data.escalated_timestamp * 1000).format('lll')
          : '',
      )}`}
    >
      <ForwardSharpIcon size="sm" />
    </PillWrapper>
  );
};
